import React from "react";
import { useTranslation } from "react-i18next";

const About: React.FC = () => {
  const { t, i18n } = useTranslation();
  if (i18n.language === "fr") {
    return (
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">
          Bienvenue chez Manager Food! 🍽️
        </h1>
        <div className="max-w-3xl mx-auto text-lg text-gray-700 space-y-6 text-center">
          <p className="font-semibold text-xl">
            Plongez au cœur des saveurs africaines authentiques!
          </p>
          <p>
            Chez Manager Food, nous célébrons la richesse culinaire de l’Afrique
            à travers des repas traditionnels, des grillades savoureuses et une
            ambiance conviviale qui vous fera voyager sans quitter votre siège.
          </p>
          <p>
            Que vous veniez pour un bon plat fait maison, pour partager un
            moment entre amis ou simplement pour découvrir de nouvelles saveurs,
            notre équipe vous accueille avec le sourire et la passion du goût.
          </p>
          <p className="font-semibold">
            Des plats généreux, des épices envoûtantes, une expérience
            inoubliable.
          </p>
          <p className="font-bold text-xl text-center mt-8">
            Bienvenue chez Manager Food, là où la cuisine africaine prend vie!
          </p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">
          Welcome to Manager Food! 🍽️
        </h1>
        <div className="max-w-3xl mx-auto text-lg text-gray-700 space-y-6 text-center">
          <p className="font-semibold text-xl">
            Dive into the heart of authentic African flavors!
          </p>
          <p>
            At Manager Food, we celebrate the culinary richness of Africa
            through traditional meals, delicious grilled dishes, and a friendly
            atmosphere that will transport you without leaving your seat.
          </p>
          <p>
            Whether you are coming for a great homemade dish, to share a moment
            with friends, or simply to discover new flavors, our team welcomes
            you with a smile and a passion for taste.
          </p>
          <p className="font-semibold">
            Generous dishes, captivating spices, an unforgettable experience.
          </p>
          <p className="font-bold text-xl text-center mt-8">
            Welcome to Manager Food, where African cuisine comes alive!
          </p>
        </div>
      </div>
    );
  }
};

export default About;
